import I18n from "i18n-js"
import moment from "moment"
import "moment/locale/es"
import "moment/locale/es-us"
import "moment/locale/id"
import "moment/locale/vi"

moment.locale(I18n.locale);
